import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsersService } from '../../services/users/users.service';
import { IRegisterUser } from '@app/shared/interfaces/users.interface';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProfilesService } from '../../services/profiles/profiles.service';
import { take } from 'rxjs';

export interface IDialogParams {
  id?: string;
  email: string;
  name: string;
  lastName?: string;
  permission: Array<string>;
  user: string;
  action?: 'edit' | 'create';
}

enum Permission {
  TVF = 'TVF',
  IPS = 'IPS',
}
@Component({
  selector: 'app-form-user',
  templateUrl: './form-user.component.html',
  styleUrls: ['./form-user.component.sass'],
})
export class FormUserComponent implements OnInit {
  formUser!: FormGroup;
  profileList: any;
  constructor(
    private fb: FormBuilder,
    private userService: UsersService,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<FormUserComponent>,
    private permissions: ProfilesService,
    @Inject(MAT_DIALOG_DATA) public paramsDialog: IDialogParams | any
  ) {}

  async ngOnInit(): Promise<void> {
    this.formUser = this.fb.group({
      id: [''],
      name: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      groupId: ['', [Validators.required]],
    });

    if (this.paramsDialog.id) {
      const { id, name, lastName, email, permission } = this.paramsDialog;

      this.formUser.patchValue({ id, name, lastName, email, groupId: permission.at(0) });
    }

    this.profileList = await this.permissions.getProfiles().pipe(take(1)).toPromise();
  }

  save(data: IRegisterUser) {
    const groupID = this.profileList?.find((ref: any) => ref.name === data.groupId)?.id;

    const updateData = {
      ...data,
      groupId: groupID,
    };

    const createData = { ...updateData };
    delete createData.id;

    const apiCall = data.id
      ? this.userService.updateUser(updateData)
      : this.userService.createUser(createData);

    apiCall.subscribe({
      next: (response: any) => {
        const action = data.id ? 'atualizado' : 'cadastrado';
        this.toastr.success(`Usuário ${data.name} ${action} com sucesso.`);

        this.formUser.reset();
        this.dialogRef.close({ up: true });
      },
      error: (err: any) => {
        this.toastr.error(err.errors);
      },
    });
  }
}
